const TRANSACTION_TYPES = Object.freeze({
  AWARD: "award",
  REDEEM: "redeem",
  CORRECTION: "correction"
})

/** Staff/admin list + export scope for the PASS-8103 transactions contract. */
const TRANSACTION_SCOPES = Object.freeze({
  MINE: "mine",
  SCHOOL_WIDE: "schoolWide"
})

/**
 * GET — `apiV8nocache` base is already `/api/v8`.
 *
 * PASS-8103 exposes one PASS transaction-list route. PASS selects the PBIS
 * report behind this endpoint; the frontend must not call PBIS reporting routes
 * or infer an `/admin/pbis/transactions` route.
 */
const TRANSACTIONS_API_PATH = "/pbis/transactions"
const TRANSACTIONS_EXPORT_API_PATH = "/pbis/transactions/export"
const STUDENT_TRANSACTIONS_API_PATH = "/student/pbis/points/transactions"
const SCHOOL_WIDE_POINTS_SUMMARY_API_PATH = "/admin/pbis/reports/points/summary"
const MY_POINTS_SUMMARY_API_PATH = "/pbis/reports/points/summary/mine"
const STUDENT_POINTS_SUMMARY_API_PATH = "/student/pbis/points/summary"

export default {
  TRANSACTION_TYPES,
  TRANSACTION_SCOPES,
  TRANSACTIONS_API_PATH,
  TRANSACTIONS_EXPORT_API_PATH,
  STUDENT_TRANSACTIONS_API_PATH,
  SCHOOL_WIDE_POINTS_SUMMARY_API_PATH,
  MY_POINTS_SUMMARY_API_PATH,
  STUDENT_POINTS_SUMMARY_API_PATH
}
